/// This class is a simple helper to determine if an element is in view
/// </summary>
export default class Visibility {
  /// <summary>
  /// Simple helper to turn true or false if an element is determined
  /// to be in view for the user
  /// </summary>
  /// <param name="elem">The element to check if it is in view</param>
  /// <return>True if the element is visible to the user</return>
  IsElementVisible(elem: HTMLElement): boolean {
    const docViewTop = window.scrollY;
    const docViewBottom = docViewTop + window.innerHeight;

    if (!elem) return false;

    const elemRect = elem.getBoundingClientRect();
    const elemTop = elemRect.top + window.scrollY;
    const elemBottom = elemTop + elemRect.height;

    // 'or' to allow a partial visible element to return true
    return (elemBottom <= docViewBottom) || (elemTop >= docViewTop);
  }
}